module.exports = "/_next/static/images/Elena_Luca-dd812547240821055af9885cddb02f5e.webp";